import SEOSchema from '@/components/feature/SEOSchema';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Features from './components/Features';
import Reviews from './components/Reviews';
import Guide from './components/Guide';
import Activities from './components/Activities';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91牛',
  alternateName: '91牛官网',
  url: 'https://91niu.com/',
  description: '91牛是专业平台，为用户提供优质服务与资源。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://91niu.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91牛',
  url: 'https://91niu.com/',
  description: '专业互联网服务平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-XXX-XXXX',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEOSchema
        schema={[homeSchema, orgSchema]}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Reviews />
        <Guide />
        <Activities />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}